import { getResolvedRef as e } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { deSerializeParameter as t, getExampleFromSchema as n, isParamDisabled as r, serializeContentValue as i, serializeCookieStyle as a, serializeDeepObjectStyle as o, serializeFormStyle as s, serializeFormStyleForCookies as c, serializePipeDelimitedStyle as l, serializeSimpleStyle as u, serializeSpaceDelimitedStyle as d } from "@scalar/workspace-store/request-example";
import { isObjectLike as f } from "@scalar/helpers/object/is-object";
import { getParameterExample as p } from "@scalar/workspace-store/helpers/get-parameter-example";
import { getQuerystringParameter as m, serializeQuerystringParameter as h } from "@scalar/workspace-store/helpers/querystring-parameter";
//#region src/code-example/helpers/operation-to-har/process-parameters.ts
var g = (t) => (t ?? []).map((t) => e(t)).filter((e) => e !== void 0), _ = (e) => "allowReserved" in e && e.allowReserved !== void 0 ? e.allowReserved : "schema" in e && e.schema && typeof e.schema == "object" && "allowReserved" in e.schema ? e.schema.allowReserved === !0 : !1, v = (e, t) => _(t) ? e : encodeURIComponent(e), y = (e) => {
	if (e.in === "header") return {
		style: "simple",
		explode: "explode" in e && e.explode !== void 0 && e.explode
	};
	if (e.in === "cookie") {
		let t = "explode" in e && e.explode !== void 0 ? e.explode : !0;
		return {
			style: "style" in e && e.style === "cookie" ? "cookie" : "form",
			explode: t
		};
	}
	let t = {
		path: "simple",
		query: "form",
		querystring: "form",
		header: "simple",
		cookie: "form"
	}[e.in], n = "style" in e && e.style ? e.style : t;
	return {
		style: n,
		explode: "explode" in e && e.explode !== void 0 ? e.explode : n === "form"
	};
}, b = (i, a, o) => {
	let s = p(i, a), c = s.example;
	if (r(i, c, o)) return;
	if (s.value !== void 0) return t(s.value, i);
	if (!("schema" in i) || !i.schema) return;
	let l = i.in === "path" ? { emptyString: `{${i.name}}` } : {}, u = e(i.schema);
	return u ? n(u, l) : void 0;
}, x = ({ harRequest: e, parameters: t, example: n, defaultDisabled: f }) => {
	let _ = [...e.headers], x = [...e.queryString], C = [...e.cookies], w = [], T = e.url, E = [], D = [], O = g(t);
	for (let e of O) {
		if (!e.in || !e.name) continue;
		if (e.in === "querystring") {
			let t = m(e, n, { defaultDisabled: f });
			if (t) {
				let e = T.indexOf("#"), n = e === -1 ? "" : T.slice(e), r = (e === -1 ? T : T.slice(0, e)).split("?")[0], i = h(t);
				T = `${r}${i ? `?${i}` : ""}${n}`;
			}
			continue;
		}
		let t = p(e, n);
		if (t.serialized && !r(e, t.example, f)) {
			let n = String(t.value);
			switch (e.in) {
				case "path":
					T = T.replaceAll(`{${e.name}}`, () => n);
					break;
				case "query":
					E.push(n);
					break;
				case "header":
					_.push({
						name: e.name,
						value: n
					});
					break;
				case "cookie":
					D.push(n);
					break;
			}
			continue;
		}
		if (t.mediaSerialized && !r(e, t.example, f)) {
			let n = String(t.value);
			switch (e.in) {
				case "query":
					x.push({
						name: e.name,
						value: v(n, e)
					});
					break;
				case "header":
					_.push({
						name: e.name,
						value: n
					});
					break;
				case "path":
					T = T.replaceAll(`{${e.name}}`, () => encodeURIComponent(n));
					break;
				case "cookie":
					C.push({
						name: e.name,
						value: n
					});
					break;
			}
			continue;
		}
		let g = b(e, n, f);
		if (g === void 0) continue;
		let { style: O, explode: k } = y(e);
		switch (e.in) {
			case "path":
				T = S(T, e, g, O, k);
				break;
			case "query":
				if ("content" in e && e.content) {
					let t = i(g, Object.keys(e.content)[0] ?? "application/json");
					x.push({
						name: e.name,
						value: v(t, e)
					});
					break;
				}
				switch (O) {
					case "form": {
						let t = s(g, k);
						if (Array.isArray(t)) for (let n of t) {
							let t = n.key || e.name;
							x.push({
								name: t,
								value: v(String(n.value), e)
							});
						}
						else x.push({
							name: e.name,
							value: v(String(t), e)
						});
						break;
					}
					case "spaceDelimited": {
						let t = d(g);
						x.push({
							name: e.name,
							value: v(t, e)
						});
						break;
					}
					case "pipeDelimited": {
						let t = l(g);
						x.push({
							name: e.name,
							value: v(t, e)
						});
						break;
					}
					case "deepObject":
						if (Array.isArray(g)) {
							let t = s(g, !0);
							if (Array.isArray(t)) for (let n of t) {
								let t = n.key || e.name;
								x.push({
									name: t,
									value: v(String(n.value), e)
								});
							}
							else x.push({
								name: e.name,
								value: v(String(t), e)
							});
						} else {
							let t = o(e.name, g);
							for (let n of t) x.push({
								name: n.key,
								value: v(n.value, e)
							});
						}
						break;
					default: x.push({
						name: e.name,
						value: v(String(g), e)
					});
				}
				break;
			case "header": {
				let t = u(g, k);
				_.push({
					name: e.name,
					value: String(t)
				});
				break;
			}
			case "cookie": {
				if (O === "cookie") {
					w.push(...a(e.name, g, k));
					break;
				}
				let t = c(g, k);
				if (Array.isArray(t)) for (let n of t) {
					let t = n.key || e.name, r = n.value === null ? "null" : String(n.value);
					C.push({
						name: t,
						value: r
					});
				}
				else {
					let n = t === null ? "null" : String(t);
					C.push({
						name: e.name,
						value: n
					});
				}
				break;
			}
		}
	}
	if (w.length || D.length) {
		let e = [
			...C.map((e) => `${encodeURIComponent(e.name)}=${encodeURIComponent(e.value)}`),
			...w.map((e) => `${e.name}=${e.value}`),
			...D
		].join("; "), t = _.find((e) => e.name.toLowerCase() === "cookie");
		t ? _.splice(_.indexOf(t), 1, {
			...t,
			value: t.value ? `${t.value}; ${e}` : e
		}) : _.push({
			name: "Cookie",
			value: e
		});
	}
	if (E.length) {
		let e = T.indexOf("#"), t = e < 0 ? "" : T.slice(e), n = e < 0 ? T : T.slice(0, e);
		T = `${n}${n.includes("?") ? "&" : "?"}${E.join("&")}${t}`;
	}
	return {
		url: T,
		headers: _,
		queryString: x,
		cookies: w.length || D.length ? [] : C,
		hasCookieStyleEntries: w.length > 0 || D.length > 0,
		...E.length ? { hasSerializedQuery: !0 } : {}
	};
}, S = (e, t, n, r, i) => {
	switch (r) {
		case "matrix":
			if (i) {
				if (Array.isArray(n)) {
					let r = n.map((e) => `${t.name}=${e}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				if (f(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{;${t.name}}`, `;${t.name}=${n.join(",")}`);
			if (f(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{;${t.name}}`, `;${t.name}=${r}`);
			}
			return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
		case "label":
			if (i) {
				if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(".")}`);
				if (f(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(".");
					return e.replace(`{.${t.name}}`, `.${r}`);
				}
				return e.replace(`{.${t.name}}`, `.${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(",")}`);
			if (f(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{.${t.name}}`, `.${r}`);
			}
			return e.replace(`{.${t.name}}`, `.${n}`);
		case "simple": {
			let r = u(n, i);
			return e.replace(`{${t.name}}`, String(r));
		}
		default: return e.replace(`{${t.name}}`, String(n));
	}
};
//#endregion
export { x as processParameters };

//# sourceMappingURL=process-parameters.js.map